import React from "react";
import { DcaTime, WeekTime, WeekTimeName } from "../../../../Const";
import { useDispatch } from "react-redux";
import { CHANGE_DCA_TIME } from "../../../../actions/create-bot-type";

const DcaTimeEntry = (props) => {
  const { newBot } = props;
  const dcaTime = { ...newBot.dcaTime };
  const dispatch = useDispatch();
  const changeType = (val) => {
    dispatch({
      type: CHANGE_DCA_TIME,
      payload: {
        ...dcaTime,
        type: val,
      },
    });
  };

  const changeWeekValue = (val) => {
    dispatch({
      type: CHANGE_DCA_TIME,
      payload: {
        ...dcaTime,
        weekValue: val,
      },
    });
  };

  const changeMonthValue = (val) => {
    dispatch({
      type: CHANGE_DCA_TIME,
      payload: {
        ...dcaTime,
        monthValue: val,
      },
    });
  };

  const weekOptions = Object.keys(WeekTime).map((el, id) => (
    <option key={id} value={WeekTime[el]}>
      {WeekTimeName[el]}
    </option>
  ));

  const monthOptions = Array.from({ length: 31 }, (_, i) => String(i + 1)).map(
    (el, id) => (
      <option key={id} value={el}>
        {el}
      </option>
    )
  );
  return (
    <div>
      <div>
        <input
          type="radio"
          name="time"
          value={DcaTime.daily}
          checked={dcaTime.type === DcaTime.daily}
          onChange={(e) => changeType(e.target.value)}
        />
        <label>Every Day</label>
      </div>
      <div>
        <input
          type="radio"
          name="time"
          value={DcaTime.weekly}
          checked={dcaTime.type === DcaTime.weekly}
          onChange={(e) => changeType(e.target.value)}
        />
        <label>Every</label>
        <select
          value={dcaTime.weekValue}
          onChange={(e) => changeWeekValue(e.target.value)}
        >
          {weekOptions}
        </select>
      </div>
      <div>
        <input
          type="radio"
          name="time"
          value={DcaTime.monthly}
          checked={dcaTime.type === DcaTime.monthly}
          onChange={(e) => changeType(e.target.value)}
        />
        <label>Every</label>
        <select
          value={dcaTime.monthValue}
          onChange={(e) => changeMonthValue(e.target.value)}
        >
          {monthOptions}
        </select>
        day of the month
      </div>
    </div>
  );
};

export default DcaTimeEntry;
